export default "__VITE_ASSET__3d94c6c1__"